import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurNewYork = () => (
  <SEOPageTemplate
    city="New York"
    state="NY"
    route="/chauffeur-new-york-ny"
    imageSrc="/nyc-limo.jpg"
    introduction="Navigating NYC traffic requires more than a car — it requires a seasoned chauffeur who understands the pulse of the city. At TiLimousine, our professional drivers know every shortcut, every FBO, and every corporate address in Manhattan. Whether you're heading to a Wall Street meeting, catching a flight from Teterboro, or attending a Broadway show, our luxury chauffeur service ensures you arrive in style and on time."
    testimonial={{
      quote: "I booked TiLimousine from Teterboro to Manhattan for an investor meeting. The chauffeur knew exactly which route to take during rush hour, and I arrived 15 minutes early. Professional, discreet, and worth every penny.",
      author: "Laura K.",
      role: "CFO, Manhattan Investment Firm"
    }}
    fboLink={{
      url: "https://signatureflight.com/locations/nyc",
      name: "Signature Aviation – Teterboro"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: NYC ⇄ Boston, NYC ⇄ Philadelphia',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in New York City',
      'Best chauffeur in New York',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service NYC',
      'Best executive car service in Manhattan',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Teterboro Airport (TEB)',
      'John F. Kennedy International Airport (JFK)',
      'LaGuardia Airport (LGA)',
      'Newark Liberty International Airport (EWR)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Meridian Teterboro',
      'Jet Aviation Teterboro'
    ]}
    neighborhoods={[
      'Manhattan',
      'Financial District',
      'Midtown',
      'Upper East Side',
      'Upper West Side',
      'Chelsea',
      'SoHo',
      'Tribeca',
      'Brooklyn Heights',
      'DUMBO',
      'Long Island City',
      'Jersey City'
    ]}
  />
);

export default ChauffeurNewYork; 